import React from "react";
import Navbar from "../../../../src/component/Navbar";

function TermsAndConditions() {
  return (
    <>
      <div className="pt-28 pb-8 bg-gray-50 min-h-screen">
        <Navbar homePage={false} />
        <div className="pt-8 mx-auto p-12 max-w-4xl bg-white rounded-xl shadow-md">
          <h1 className="text-3xl font-bold text-gray-900 mb-6 uppercase">
            Terms & Conditions
          </h1>

          <section className="mb-6">
            <h3 className="text-2xl font-semibold mb-2">1. Acceptance of Terms</h3>
            <p className="text-gray-700 leading-relaxed">
              By accessing or using NOTAM.ae (the “Website”), you agree to comply with and be bound by these Terms and Conditions. If you do not agree with these terms, please do not use the Website.
            </p>
          </section>

          <section className="mb-6">
            <h3 className="text-2xl font-semibold mb-2">2. Purpose of the Website</h3>
            <p className="text-gray-700 leading-relaxed">
              NOTAM.ae provides a centralized interface for visualizing and sharing aviation Notices to Airmen (NOTAMs) from publicly available data sources. The platform is designed for display and awareness purposes only.
            </p>
          </section>

          <section className="mb-6">
            <h3 className="text-2xl font-semibold mb-2">3. User Eligibility and Registration</h3>
            <ul className="list-disc pl-5 space-y-1 text-gray-700 leading-relaxed">
              <li>Registration is open to the public.</li>
              <li>Users must provide accurate and complete information during registration.</li>
              <li>Users are responsible for maintaining the confidentiality of their account credentials.</li>
            </ul>
          </section>

          <section className="mb-6">
            <h3 className="text-2xl font-semibold mb-2">4. User Responsibilities</h3>
            <ul className="list-disc pl-5 space-y-1 text-gray-700 leading-relaxed">
              <li>
                <strong>NOTAMs Are Public by Nature:</strong> By definition, a NOTAM is public information intended for the benefit of the aviation community. Any NOTAM published via this platform is meant to inform others and contribute to public safety and awareness.
              </li>
              <li>
                <strong>User Accountability for Posted NOTAMs:</strong> Users who upload or share NOTAMs on this platform are solely responsible for ensuring their accuracy and timeliness. If a NOTAM becomes outdated, inaccurate, or is no longer relevant, it is the user’s responsibility to update or cancel it.
              </li>
              <li>
                <strong>Proper Use:</strong> Users agree not to post false or misleading data. Any misuse or abuse of the platform may result in account suspension or removal.
              </li>
            </ul>
          </section>

          <section className="mb-6">
            <h3 className="text-2xl font-semibold mb-2">5. Content Integrity and Accuracy</h3>
            <ul className="list-disc pl-5 space-y-1 text-gray-700 leading-relaxed">
              <li>NOTAM.ae does not create or modify NOTAM content.</li>
              <li>The platform aggregates and displays existing NOTAMs as visual overlays to aid in understanding.</li>
              <li>The Website does not guarantee the accuracy, completeness, or currency of the NOTAMs displayed.</li>
              <li>Users must verify all NOTAM information through official aviation authorities before making any flight or operational decisions.</li>
            </ul>
          </section>

          <section className="mb-6">
            <h3 className="text-2xl font-semibold mb-2">6. Intellectual Property</h3>
            <ul className="list-disc pl-5 space-y-1 text-gray-700 leading-relaxed">
              <li>Website design and interface are the property of NOTAM.ae.</li>
              <li>Users retain rights to their own submitted content, but by posting it, grant NOTAM.ae a non-exclusive, royalty-free license to display and distribute it.</li>
            </ul>
          </section>

          <section className="mb-6">
            <h3 className="text-2xl font-semibold mb-2">7. Privacy</h3>
            <p className="text-gray-700 leading-relaxed">
              Refer to our <a href="/privacy-policy" className="text-blue-600 hover:underline">Privacy Policy</a> for details on how we collect, store, and use your information.
            </p>
          </section>

          <section className="mb-6">
            <h3 className="text-2xl font-semibold mb-2">8. Account Termination</h3>
            <p className="text-gray-700 leading-relaxed">
              NOTAM.ae reserves the right to suspend or terminate any account found in violation of these terms or for any action that compromises platform integrity.
            </p>
          </section>

          <section className="mb-6">
            <h3 className="text-2xl font-semibold mb-2">9. Changes to Terms</h3>
            <p className="text-gray-700 leading-relaxed">
              These Terms and Conditions may be updated periodically. We will notify users of significant changes, and continued use of the site implies acceptance of the revised terms.
            </p>
          </section>
        </div>
      </div>
    </>
  );
}

export default TermsAndConditions;
